export const css = {
    root: '_1JKD7Ddu',
    studyplan_carousel: '_2QrAzgYJ',
    domain_carousels: '_19z2qwsm',
    ' _key': 'afcpe-theme/afcpe/explore-view/carousel-view'
};
export default css;
